export enum OrderStatusEnum {
  Pending = "pending",
  Paid = "paid",
  Cancelled = "cancelled",
  Processing = "processing",
  Shipped = "shipped",
  Completed = "completed",
  Refunded = "refunded",
}
